import React from "react";
import AllUsersTable from "../Components/UsersManagement/AllUsers/AllUsersTable";
import Btn from "../Components/UsersManagement/AllUsers/Btn";

function AllUsers() {
  return (
    <div>
      <div className="flex justify-between items-center py-7 px-10">
        <Btn />
      </div>
      <div className="px-10">
        <AllUsersTable />
      </div>
    </div>
  );
}

export default AllUsers;
